<template>
    <div class="order-main">
        <van-sticky
            v-if="isWechat"
            type="primary"
        >
            <!-- 导航栏 -->
            <van-nav-bar
                title="订单详情"
                left-text="返回"
                left-arrow
                @click-left="onGoBack"
            />
        </van-sticky>
        <!-- 订单状态区域 -->
        <div class="order__order-state-wrapper">
            <!-- 订单状态 -->
            <div class="order__order-state">
                <van-row type="flex" align="center" justify="start" gutter="8">
                    <van-icon size="28" name="checked" color="#17161c"/>
                    <span class="order__order-state-title">{{orderStateStr}}</span>
                </van-row>
                <van-button
                    v-if="orderState === 'TO_RECEIVE' || orderState==='SUCCESS'"
                    class="order__view-account-button"
                    type="default"
                    @click="onGoTicket"
                >
                    查看卡券
                </van-button>
            </div>
        </div>
        <!-- 订单商品区域 -->
        <div class="order__goods-list-wrapper">
            <div class="order__order-info-wrapper">
                <!-- 店铺信息 -->
                <van-row type="flex" justify="space-between" class="order__header-info-wrapper">
                    <van-col>
                        <van-row class="order__order-info-shop-wrapper" type="flex" align="center" gutter="1">
                            <van-icon class="order__order-info-shop-icon" size="16" name="shop-o" />
                            <span class="order__order-info-shop">海藻票务</span>
                        </van-row>
                    </van-col>
                </van-row>
                <!-- 商品信息 -->
                <van-row class="order__goods-wrapper" type="flex">
                    <!-- 商品头图 -->
                    <van-col class="order__goods-avatar-wrapper">
                        <van-image :src="coverPic" width="72" height="72"/>
                    </van-col>
                    <!-- 商品详细信息 -->
                    <van-col class="order__goods-info-wrapper">
                        <van-row class="order__goods-info-title">{{skuName}}</van-row>
                        <van-row class="order__goods-info-num">x {{num}}</van-row>
                        <van-row class="order__goods-info-price" type="flex" justify="end">¥ {{skuPriceYuan}}</van-row>
                    </van-col>
                </van-row>
                <!-- 订单操作按钮 -->
                <van-row type="flex" class="order__action-bar" justify="end" gutter="4">
                    <van-col v-if="orderState === 'TO_PAY'">
                        <van-button class="to-pay" size="small" round type="primary" color="#17161c" @click="payOrder">去支付</van-button>
                    </van-col>
                    <van-col v-if="orderState === 'TO_PAY'">
                        <van-button size="small" round type="default" @click="closeOrder">取消订单</van-button>
                    </van-col>
                    <van-col v-if="orderState === 'TO_RECEIVE'">
                        <van-button size="small" plain round color="#17161c" type="default" @click="postSale">发起售后</van-button>
                    </van-col>
                    <van-col v-if="orderState === 'TO_RECEIVE'">
                        <van-button size="small" class="to-pay" round color="#17161c" type="primary" @click="ensureOrder">确认收货</van-button>
                    </van-col>
                    <van-col v-if="orderState === 'POST_SALE'">
                        <van-button size="small" class="to-pay" round color="#17161c" type="primary" @click="cancelPostSale">取消售后</van-button>
                    </van-col>
                </van-row>
                <!-- 订单实际支付金额 -->
                <van-row
                    v-if="actualPaymentPrice != undefined && actualPaymentPrice != null"
                    type="flex"
                    justify="end"
                    align="bottom"
                    class="order__payment-wrapper"
                    gutter="8"
                >
                    <van-col>
                        <span class="order__payment-title">实付款</span>
                    </van-col>
                    <van-col>
                        <span class="order__payment-currency">¥</span>
                        <span class="order__payment-actual-price">{{actualPaymentPriceYuan}}</span>
                    </van-col>
                </van-row>

            </div>
        </div>
        <!-- 售后信息 -->
        <div class="order__post-sale-info-wrapper"
            v-if="orderState === 'POST_SALE' || orderState === 'REFUNDED' || orderState==='NEGATIVE'"
        >
            <van-row class="order__post-sale-info-title">售后信息</van-row>
            <!-- 售后信息 -->
            <van-row>
                <van-uploader
                    v-model="evidenceFileList"
                    :show-upload="false"
                />
            </van-row>
            <van-row class="order__post-sale-item-title">售后原因：{{postSaleReason}}</van-row> 
            <van-row class="order__post-sale-item-title">处理答复：{{processReason ? processReason : "无"}}</van-row>
        </div>
        <!-- 订单信息 -->
        <div class="order__order-info-wrapper">
            <van-row class="order__order-info-gutter">
                <van-col class="order__order-title">订单信息</van-col>
            </van-row>
            <van-row class="order__order-info-gutter">
                <van-col span="6">订单编号：</van-col>
                <van-col span="17">{{orderNo}}</van-col>
            </van-row>
            <van-row class="order__order-info-gutter">
                <van-col span="6">订单时间：</van-col>
                <van-col span="17">{{orderTime}}</van-col>
            </van-row>
            <van-row v-if="paidTime" class="order__order-info-gutter">
                <van-col span="6">付款时间：</van-col>
                <van-col span="17">{{paidTime}}</van-col>
            </van-row>
            <van-row v-if="ensuredTime" class="order__order-info-gutter">
                <van-col span="6">确认时间：</van-col>
                <van-col span="17">{{ensuredTime}}</van-col>
            </van-row>
        </div>
    </div>
</template>

<script>
import {NavBar, Col, Row, Image, Icon, Button, Sticky, Uploader} from "vant";
import {navMixins, wechatMixins} from "@/mixins.js";
import {orderStateMap} from "@/constant.js";
import request from "@/utils/request.js";
import wechat from "@/utils/wechat.js"
export default {
    name: "Order",
    mixins: [navMixins, wechatMixins],
    components: {
        [NavBar.name]: NavBar,
        [Col.name]: Col,
        [Row.name]: Row,
        [Image.name]: Image,
        [Icon.name]: Icon,
        [Button.name]: Button,
        [Sticky.name]: Sticky,
        [Uploader.name]: Uploader
    },
    props: {
    },
    data() {
        return {
            orderState: undefined,
            orderNo: undefined,
            paidTime: undefined,
            ensuredTime: undefined,
            orderTime: undefined,
            itemList: [],
            actualOrderPrice: 0,
            actualPaymentPrice: undefined,
            num: 1,
            skuPrice: 0,
            skuName: "",
            skuCode: undefined,
            coverPic: "",

            postSaleReason: undefined,
            evidenceList: [],
            processReason: undefined
        };
    },
    computed: {
        orderStateStr() {
            return orderStateMap(this.orderState);
        },
        actualPaymentPriceYuan() {
            return (this.actualPaymentPrice / 100).toFixed(2);
        },
        skuPriceYuan() {
            return (this.skuPrice / 100).toFixed(2);
        },
        evidenceFileList() {
            if (this.evidenceList) {
                
                return this.evidenceList.map(evidence => {
                    return {
                        url: evidence,
                        deletable: false
                    };
                });
            }
            return [];
        }
    },
    mounted() {
        this.orderNo = this.$route.params.order_no;
        this.loadOrder();
    },
    methods: {
        async loadOrder() {
            const {data} = await request.get(`/customer/order/loadTicketOrderDetail?orderNo=${this.orderNo}`);

            this.actualOrderPrice = data.actualOrderPrice;
            this.actualPaymentPrice = data.actualPaymentPrice;
            this.orderNo = data.orderNo;
            this.orderState = data.orderState;
            this.paidTime = data.paidTime;
            this.ensuredTime = data.ensuredTime;
            this.orderTime = data.createTime;
            this.itemList = data.itemList;
            this.num = data.itemList[0].num;
            this.skuPrice = data.itemList[0].skuPrice;
            this.skuName = data.itemList[0].skuName;
            this.skuCode = data.itemList[0].skuCode;
            this.coverPic = data.itemList[0].skuCoverPic;

            // 售后相关
            this.evidenceList = data.evidenceList;
            this.postSaleReason = data.reason;
            this.processReason = data.processReason;

        },
        onGoTicket() {
            this.$router.push(`/ticket/${this.orderNo}`);
        },
        async payOrder() {
            const {data} = await request.post('/customer/payment/createPayOrder', {
                    data: {
                    orderNo: this.orderNo,
                    payType: "WECHAT_JSAPI"
                }
            });
            const paymentParam = JSON.parse(data.paymentParam);
            // 拉起Wap支付
            wechat.triggerWapPayment(paymentParam.appId,
                                    paymentParam.timeStamp,
                                    paymentParam.nonceStr,
                                    paymentParam.package,
                                    paymentParam.signType,
                                    paymentParam.paySign, () => {
                                        this.loadOrder();
                                    });
        },
        async closeOrder() {
            const {response} = await request.get(`/customer/order/closeOrder?orderNo=${this.orderNo}`);
            if (response.ok) {
                this.$notify({message: "取消成功", type: "success"});
                this.loadOrder();
            }
        },
        async postSale() {
            this.$router.push(`/post-sale?orderNo=${this.orderNo}&skuCode=${this.skuCode}&skuName=${this.skuName}`);
        },
        async ensureOrder() {
             const {response} = await request.get(`/customer/order/ensureOrder?orderNo=${this.orderNo}`); 
            if (response.ok) {
                this.$notify({message: "确认收货", type: "success"});
                this.loadOrder();
            }
        },
        async cancelPostSale() {
            const {response} = await request.get(`/customer/order/cancelPostSale?orderNo=${this.orderNo}`); 
            if (response.ok) {
                this.$notify({message: "取消成功", type: "success"});
                this.loadOrder();
            }
        }
    }
}
</script>

<style lang="less">
@import "@/style/base.less";
.order-main {
    .van-nav-bar {
        background: linear-gradient(to right, #ff6034, #ee0a24);
    }
    .van-nav-bar.van-hairline--bottom::after {
        border: none;
    }

    // 导航栏文字
    .van-nav-bar__text {
        color: white;
    }

    .van-icon.van-nav-bar__arrow {
        color: white;
    }

    .van-nav-bar__title {
        color: white;
    }

}

.order__order-state-wrapper {
    // background: linear-gradient(to right, #ff6034, #ee0a24);
    background: @color-vice;
    padding: 16px;
}

.order__order-state {
    // color: @color-theme;
    background-color: white;
    border-radius: 8px;
    padding: 8px 4px 4px 4px;
}

.order__order-state-title {
    font-size: @font-size-title;
    color: @font-color-title;
    font-weight: @font-weight-title;
    line-height: @line-height-title;
    margin-left: 8px;
}

.order__view-account-button {
    color: @font-color-title;
    font-weight: @font-weight-title;
    width: 100%;
    text-align: center;
    border-radius: 8px;
    padding: 4px 0;
    background-color: #ebecefd1;
    height: 40px;
    line-height: 40px;
    margin-top: 8px;
}

.order__goods-list-wrapper {
    background: white;
    margin-top: 8px;
}
.order__order-info-wrapper {
    padding: 16px;
}

.order__header-info-wrapper {
}

.order__order-info-shop-icon {
    vertical-align: middle;
}

.order__order-info-shop {
    font-size: @font-size-normal;
    line-height: @line-height-normal;
    color: @font-color-title;
    font-weight: @font-weight-normal;
}
.order__goods-wrapper {
    margin-top: 8px;
}

.order__goods-info-wrapper {
    flex-grow: 1;
    margin-left: 16px;
}
.order__goods-info-title {
    font-size: @font-size-title;
    color: @font-color-title;
    font-weight: @font-weight-title;
    line-height: @line-height-title;
}
.order__goods-info-num {
    text-align: right;
}

.order__goods-info-price {

}

.order__action-bar {
    .van-button {
        height: 30px;
    }
    .van-button--small {
        padding: 0 12px
    }

    .to-pay {
        color:  @color-vice-font!important;
    }
}
.order__payment-wrapper {
    margin-top: 16px;
}

.order__payment-title {
    font-size: @font-size-normal;
    color: @font-color-title;
    font-weight: @font-weight-title;

}

.order__payment-currency {
    font-size: @font-size-normal;
    color: @color-theme;
    font-weight: @font-weight-normal;
}

.order__payment-actual-price {
    font-size: @font-size-title;
    color: @color-theme;
    font-weight: @font-weight-title;
}

.order__order-info-wrapper {
    margin-top: 8px;
    background-color: white;
    padding: 16px;
    font-size: @font-size-normal;
    font-weight: @font-weight-normal;
    color: @font-color-title;
}

.order__order-title {
    font-size: @font-size-title;
    font-weight: @font-weight-title;
}

.order__order-info-gutter {
    margin: 16px 0;
}

.order__post-sale-info-title {
    color: @font-color-title;
    font-size: @font-size-title;
    line-height: @line-height-title;
    padding: 8px 0;
}

.order__post-sale-info-wrapper {
    margin-top: 8px;
    background-color: white;
    padding: 16px;
}

.order__post-sale-item-title {
    color: @font-color-title;
    line-height: @line-height-title;
    font-size: @font-size-normal;
    font-weight: @font-weight-normal;
}

</style>